import { Config } from '@ratehub/base-ui';


const PAGES = {
    BASE_ROUTE: Config.INS_LIFE_WIZARD_BASE_ROUTE_EN,
    BASE_ROUTE_FR: Config.INS_LIFE_WIZARD_BASE_ROUTE_FR,
    COVERAGE_DETAILS: {
        id: 'CoverageDetailsPage',
        route: '/:insuranceType/coverage-details',
    },
    PERSONAL_DETAILS: {
        id: 'PersonalDetailsPage',
        route: '/:insuranceType/personal-details',
    },
    CONFIRMATION: {
        id: 'ConfirmationPage',
        route: '/:insuranceType/confirmation',
    },
};

export default PAGES;
